import request from "@/utils/request";
import { apiConfig } from "../config/api";

//登录
export function login(username, password) {
  var params = {
    username,
    password
  };

  return request({
    url: apiConfig.auth.api.login,
    method: "post",
    params: params
  });
}

//检查token
export function checkToken(silent401) {
  return request({
    url: apiConfig.auth.api.checkToken,
    method: "get",
    silent401
  });
}

//更新密码
export function updateCurrentPassword(oldPassword, newPassword) {
  return request({
    url: apiConfig.auth.api.changePassword,
    method: "post",
    params: {
      oldPassword: oldPassword,
      password: newPassword
    }
  });
}

//登出
export function logout() {
  return request({
    url: apiConfig.auth.api.logout,
    method: "post"
  });
}

//获取考场生产及开发环境路径
export function getExamUrl() {
  return request({
    url: apiConfig.auth.api.getExamUrl,
    method: "get"
  });
}

//获取用户人数和当前在线人数
export function getOnlineUsers() {
  return request({
    url: apiConfig.auth.api.getOnlineUsers,
    method: "get"
  });
}

//获取在新用户信息
export function getOnlineUsersList(req) {
  return request({
    url: apiConfig.auth.api.getOnlineUsersList,
    method: "get",
    params: {
      realName: req.realName,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}

//获取图性验证码
export function captcha() {
  return request({
    url: apiConfig.auth.api.captcha,
    method: "get"
  });
}

//机构登录换取code
export function getOauthCode(params) {
  return request({
    url: apiConfig.auth.api.getOauthCode,
    method: "get",
    params
  });
}

//oauthCode登录
export function loginByOauthCode(params) {
  return request({
    url: apiConfig.auth.api.loginByOauthCode,
    method: "post",
    params
  });
}

//组织注册信息提交
export function organizationRegister(req) {
  return request({
    url: apiConfig.auth.api.organizationRegister,
    method: "post",
    data: req
  });
}

//查询合作平台机构
export function getCooperationPlatform(params) {
  return request({
    url: apiConfig.auth.api.getCooperationPlatform,
    method: "get",
    params
  });
}
